export default "__VITE_ASSET__PrDmEKil__"